import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl24 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_24",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Arrow",
			className: "black",
			d: "M56,31.88c-.03-1.84-.78-3.59-2.09-4.87-1.31-1.29-3.07-2.01-4.91-2.01h-16.58l2.38-2.39c.14-.18.21-.39.21-.61s-.07-.44-.21-.61l-.08-.09-.09-.08c-.18-.14-.39-.21-.61-.21s-.44.07-.61.21l-4.18,4.18c-.14.18-.21.39-.21.61s.07.44.21.61l4.18,4.18c.19.15.43.22.68.21.24-.02.47-.12.64-.29.17-.17.28-.4.29-.64s-.06-.48-.21-.68l-2.38-2.39h16.8c1.3.06,2.54.63,3.43,1.58.89.95,1.38,2.22,1.35,3.52-.03,1.31-.57,2.55-1.5,3.46-.84.82-1.95,1.3-3.12,1.39l-4.67-4.67c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l3.29,3.29h-9.59s-.02,0-.03,0h-.2c-.25.03-.48.16-.65.35-.16.2-.25.45-.23.7.01.25.13.49.31.67s.43.27.68.27h.12s0,0,0,0h9.59l-3.29,3.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l4.73-4.73c1.76-.11,3.42-.87,4.64-2.16,1.26-1.33,1.96-3.11,1.92-4.94Z"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "ICE_Sideview",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M34,49H9c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M25,53H9c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M21.76,42.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72h0l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.44.43.48.74.04.31-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
				})
			]
		})]
	})]
});
export default SvgAppIcBefehl24;
